import {fetchView} from './viewService';
import {selectViewById} from './viewSelectors';
import * as AppConstants from 'app/AppConstants';

export const loadViewById = viewId => (dispatch, getState) => {
  if (selectViewById(getState(), viewId)) return Promise.resolve();

  return fetchView(viewId).then(response => {
    dispatch({
      type: AppConstants.VIEW__LOAD_FINISHED,
      payload: {
        viewId,
        view: response,
      },
    });
  });
};
